const usePhoneNumberVerification = (requiresPhoneNumberVerification, isPhoneNumberVerified) => {
  const showDefaultPhoneInput = !requiresPhoneNumberVerification || requiresPhoneNumberVerification && isPhoneNumberVerified;
  const showVerificationPhoneInput = requiresPhoneNumberVerification && !isPhoneNumberVerified;
  return {
    showDefaultPhoneInput,
    showVerificationPhoneInput
  };
};

export { usePhoneNumberVerification };
//# sourceMappingURL=usePhoneNumberVerification.js.map
